import httpClient from './httpClient';

const END_POINT = '/api/functionalities';
const getAllFunctionalities = (perPage = null, page = null, sort = null, filterList = null) => {
    let typePackApi = END_POINT;
    typePackApi += perPage != null ? '?itemsPerPage=' + perPage + '&page=' + page + sort + filterList : '';
    return httpClient.get(typePackApi);
};
const updateFunctionalityWithModule = (id, functionality) => httpClient.put(END_POINT + '/updateWithModules/' + id, functionality);
const deleteFunctionality = id => httpClient.delete(END_POINT + '/' + id);
const deleteFunctionalityWithModule = id => httpClient.delete(END_POINT + '/deleteWithModule/' + id);
const addFunctionalityWithModule = functionality => httpClient.post(END_POINT + '/add', functionality);

export {
    getAllFunctionalities,
    deleteFunctionality,
    addFunctionalityWithModule,
    deleteFunctionalityWithModule,
    updateFunctionalityWithModule
};
